export type SimDetailsResponse = {
	_accounts: any;
	data: SimDetails[];
};

export type SimDetails = {
	phoneNumber?: string;
	description?: string;
	simSerialNo?: string;
	eSIM?: boolean;
};

export type SimDetailsRequest = {
	phoneNumber?: string;
};

const model: types.models.InputModel = {
	_accounts: ['response.getSimDetailsResponse.accounts', []],
	data: (model: SimDetailsResponse) => model._accounts?.[0],
};

export default model;
